import api from '../lib/api';

const authService = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  checkEmail: (email) => api.get('/auth/check-email', { params: { email } }),
  register: (data) => api.post('/auth/register', data),
  refresh: (accessToken, refreshToken) => api.post('/auth/refresh', { accessToken, refreshToken }),
  logout: () => api.post('/auth/logout'),
  getMe: () => api.get('/auth/me'),
  resendVerification: (email) => api.post('/auth/resend-verification', { email }),
};

export default authService;
